// extracted by mini-css-extract-plugin
module.exports = {"firstScreenH5":"FirstScreen_firstScreenH5__Rv1fn"};